import { render, staticRenderFns } from "./whois.vue?vue&type=template&id=8a28b366&scoped=true&"
import script from "./whois.vue?vue&type=script&lang=js&"
export * from "./whois.vue?vue&type=script&lang=js&"
import style0 from "./whois.vue?vue&type=style&index=0&id=8a28b366&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a28b366",
  null
  
)

export default component.exports